import React, { Component } from 'react';

import Instafeed from 'instafeed.js'

class Unknown extends Component {

  instafed = () => {
    let userFeed = new Instafeed({
      get: 'user',
      userId: '1959308977',
      clientId: '26ea2d7e2029485da3b5abd088603d00',
      accessToken: '1959308977.26ea2d7.90cd54274f704b5d849203cf937e1aad',
      resolution: 'standard_resolution',
      template: '<div class="col-md-3"><a href="{{link}}" alt="image" target="_blank" id="{{id}}"><img class="img img-thumbnail" src="{{image}}" /></a></div>',
      sortBy: 'most-recent',
      limit: 4,
      links: false
    });
    userFeed.run();

    return (<div id="instafeed"></div>)
  }

  render() {
      return (
          <React.Fragment>
            <div style={{paddingTop:30, paddingBottom: 30, paddingLeft: 0, paddingRight: 0, backgroundColor:"#FFF"}}>
              {this.instafed()}
            </div>
          </React.Fragment>
      );
  }
}

export default Unknown;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Unknown.jsx